export const QUERY_SEPARATOR = ";";

export const DATA_TYPES = {
  user: "Your data",
  infuse: "INFUSE Data Extension",
};
